declare var THREE: any;

export interface TextToImageConfig {
  width?: number;
  height?: number;
  bold?: boolean;
  fontSize?: number;
  textColor?: string;
  font?: string;
}

interface TextSizeConfig {
  font: string;
  fontSize: number;
  bold?: boolean;
}

export class TextUtilsService {

  private static canvas = document.createElement('canvas');

  static textToImage(text: string, config: TextToImageConfig = {}, isInvisible?: boolean): HTMLCanvasElement {

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { alpha: true });

    const width = config.width || 128;
    const height = config.height || 64;

    if (!THREE.Math.isPowerOfTwo(width) || !THREE.Math.isPowerOfTwo(height)) {
      throw new Error('Texture size is not power of 2');
    }

    canvas.width = width;
    canvas.height = height;

    const style = config.bold ? 'bold' : '';
    const fontSize = config.fontSize || 12;
    const font = config.font || 'Arial';
    
    ctx.font = `${style} ${fontSize}px ${font}`;
    
    ctx.textAlign = 'center';
    ctx.fillStyle = '#ffffff';
    // ctx.fillStyle = '#000000';
    ctx.beginPath();

    // ctx.ellipse(canvas.width / 2, canvas.height / 2, canvas.width / 2, canvas.height / 2, 0, 0, 2 * Math.PI);

    ctx.moveTo(canvas.width - 32, 0);
    ctx.arc(canvas.width - 32, 32, 32, 1.5 * Math.PI, 0.5 * Math.PI);

    // ctx.lineTo(canvas.width, 32);
    // ctx.lineTo(canvas.width - 32, 64);
    ctx.lineTo(32, 64);
    ctx.arc(32, 32, 32, 0.5 * Math.PI, 1.5 * Math.PI);

    // ctx.lineTo(0, 32);
    // ctx.lineTo(32, 0);
    ctx.lineTo(canvas.width - 32, 0);



    // ctx.moveTo(canvas.width, 64);
    // ctx.arcTo(0, 64, 0, 0, 30);
    // ctx.arcTo(0, 0, canvas.width, 0, 30);
    // ctx.arcTo(canvas.width, 0, canvas.width, 64, 30);
    // ctx.arcTo(canvas.width, 64, 0, 64, 30);

    // ctx.clip();
    // ctx.fill();
    // ctx.shadowColor = '#ffffff';
    // ctx.shadowBlur = 3;
    // ctx.fillRect(0, 0, canvas.width, 64);
    if (!isInvisible) {
    }
    // ctx.lineWidth = 40;
    // ctx.strokeStyle = '#ffffff';
    // ctx.stroke;
    ctx.fillStyle = config.textColor || 'black';
    ctx.textAlign = 'center';
    ctx.fillText(text, width / 2, height / 2 + fontSize / 4);
    return canvas;
  }
  
  static getTextWidth(text: string, textSettings: TextSizeConfig) {
    const ctx = TextUtilsService.canvas.getContext('2d');
    const bold = textSettings.bold ? 'bold' : '';
    ctx.font = `${bold} ${textSettings.fontSize}px ${textSettings.font}`;
    const metrics = ctx.measureText(text);
    return metrics.width;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/textUtils.service.ts